const collapsedHeight = 135

let count = 0

function setup(el) {
  if (el.scrollHeight <= collapsedHeight + 20) return

  if (!el.id) el.id = `readmore-${++count}`
  el.style.overflow = "hidden"
  el.style.height = `${collapsedHeight}px`
  el.setAttribute("data-collapsed", "")

  const toggle = document.createElement("button")
  toggle.type = "button"
  toggle.className = "readmore__toggle"
  toggle.setAttribute("aria-controls", el.id)
  toggle.setAttribute("aria-expanded", "false")
  toggle.textContent = "More"

  toggle.addEventListener("click", () => {
    const expanded = toggle.getAttribute("aria-expanded") === "true"
    toggle.setAttribute("aria-expanded", String(!expanded))
    toggle.textContent = expanded ? "More" : "Less"
    el.style.height = expanded ? `${collapsedHeight}px` : `${el.scrollHeight}px`
    el.toggleAttribute("data-collapsed", expanded)
  })

  el.insertAdjacentElement("afterend", toggle)
}

export function initReadmore() {
  document.querySelectorAll(".readmore").forEach(setup)
}
